module.exports = __webpack_public_path__ + "img/Tony.9f698232.jpeg";